<template>
  <div>
    <b-modal
      ref="modal"
      :title="$t('partners.add_new')"
      :ok-disabled="!model.user_id"
      size="sm"
      centered
      @ok="save"
    >
      <form ref="form" @submit="save">
        <fields
          :fields="fields.all()"
          :model="model"
          :errors="errors"
          layout="vertical"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import filter from 'lodash-es/filter'
import { FormMixin } from 'stylemix-base'
import UsersApi from '../users/UsersApi'

export default {
  name: 'AddPartner',

  mixins: [FormMixin],

  data() {
    return {
      model: {
        user_id: null,
        partner: true,
        partner_commission: null,
        auto_billing: false,
      },
    }
  },

  mounted() {
    const modal = this.$refs.modal
    modal.show()

    const promise = new UsersApi().create().then(result => {
      const fields = filter(result.fields, field => {
        let only = ['partner_commission']
        return only.indexOf(field.attribute) !== -1
      })

      this.model.partner_commission = result.data.partner_commission;
      fields.unshift({
        attribute: 'user_id',
        component: 'relation-field',
        label: this.$t('partners.user'),
        ajax: true,
        source: {
          url: 'users',
          params: {
            'where[partner]': false,
            context: 'options',
          },
        },
      })

      this.setFields(fields);
    })

    modal.$on('shown', () => {
      this.$uiBlocker(promise, modal.$refs.content)
    })
  },

  methods: {
    save(event) {
      event.preventDefault()
      return this.$uiBlocker(
        new UsersApi()
          .update(this.model.user_id, this.model)
          .then(result => {
            this.$refs.modal.hide()
            this.$close(result.data)
            this.$toast.success(result.message)
          })
          .catch(error => {
            if (error.status === 422) {
              this.setValidationErrors(error.data.errors)
            }
            return Promise.reject(error)
          }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
